module.exports = __webpack_public_path__ + "img/6.2b803a7b.jpg";